export default __webpack_public_path__ + "static/media/198property-gallery1.e70cd302.webp";